var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAstrovault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 40,
    viewBox: "0 0 1107.9 493.06",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-597.47 -1.99)",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m889.81 141.55c1.37 7.6504 8.05 13.351 16.09 13.351h62.81c9.23 0 16.68-7.4604 16.68-16.491s-7.46-16.681-16.68-16.681h-62.81c-5.69 0-11.19-0.79004-16.49-2.3601-11.58-3.3402-21.79-10.211-29.44-19.241-5.1-6.2803-9.23-13.541-11.38-21.591-1.57-5.3003-2.55-10.801-2.55-16.681 0-27.091 18.45-50.253 43.38-57.513 5.3-1.5701 10.79-2.3501 16.49-2.3501h62.81c31.99 0 58.1 25.321 59.87 56.723h-43.57c-1.37-7.6504-8.24-13.351-16.29-13.351h-62.81c-9.03 0-16.49 7.4604-16.49 16.491 0 9.0305 7.46 16.681 16.49 16.681h62.81c18.45 0 35.13 8.4404 46.13 21.591 5.1 6.2803 9.03 13.741 11.38 21.591 1.57 5.3003 2.36 10.991 2.36 16.681 0 32.972-26.89 59.873-59.87 59.873h-62.81c-5.69 0-11.19-0.79004-16.49-2.3601-23.95-6.8704-41.81-28.661-43.18-54.373h43.57z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1073.8 45.36v-43.37h173.71v43.37h-65.17v152.91h-43.38v-152.91h-65.17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1302.8 1.99h110.11c35.92 0 65.17 29.44 65.17 65.16 0 29.64-19.82 54.76-46.72 62.61l46.72 68.5h-52.41l-44.95-65.76-29.64-43.38h61.83c11.97 0 21.98-10.01 21.98-21.98s-10.01-21.79-21.98-21.79h-66.73v152.92h-43.38z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1610.6 1.99c52.01 0 94.8 42.59 94.8 94.8v6.67c0 52.21-42.79 94.8-94.8 94.8s-94.61-42.59-94.61-94.8v-6.67c0-52.21 42.59-94.8 94.61-94.8zm0 43.38c-28.26 0-51.23 23.16-51.23 51.43v6.67c0 28.26 22.96 51.43 51.23 51.43s51.43-23.16 51.43-51.43v-6.67c0-28.26-23.16-51.43-51.43-51.43z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m676.64 355.7 23.945 45.54 23.75-45.54 22.755-43.381 7.123-13.541h49.275l-7.123 13.541-3.9616 7.2592-18.803 36.112-48.485 92.454-24.54 46.914-24.735-46.914-48.485-92.454-18.803-36.112-3.9616-7.2592-7.123-13.541h49.275l7.123 13.541 22.755 43.381z",
    strokeWidth: 0.97182
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1160.8 495.06c-16.06 0-31.12-4.32-44.2-11.774-25.97-15.11-43.61-43.181-43.61-75.176v-109.33h43.61v109.33c0 23.943 20.02 43.576 44.2 43.576s44-19.633 44-43.576v-109.33h43.61v109.33c0 31.995-17.44 60.065-43.61 75.176-13.08 7.4636-28.15 11.774-44 11.774z",
    strokeWidth: 0.98198
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1302.8 298.78h40.763v158.59h134.52v37.692h-175.28z",
    strokeWidth: 0.98031
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1520.6 342.16v-43.381h180.15v43.381h-67.58v152.9h-44.99v-152.9z",
    strokeWidth: 0.98196
  }), /*#__PURE__*/React.createElement("path", {
    d: "m724.33 141.35-23.95-45.532-23.75 45.532-22.76 43.38-7.12 13.538h-49.28l7.12-13.538 3.96-7.2597 18.8-36.11 48.49-92.442 24.54-46.93 24.74 46.91 48.49 92.442 18.8 36.11 3.96 7.2597 7.12 13.538h-49.28l-7.12-13.538-22.76-43.38z",
    strokeWidth: 0.99587
  }), /*#__PURE__*/React.createElement("path", {
    d: "m961.18 438.13-23.947-45.543-23.752 45.543-22.76 43.383-7.1266 13.539h-49.283l7.1266-13.539 3.9571-7.2611 18.803-36.112 48.486-92.456 24.54-46.912 24.734 46.912 48.486 92.456 18.803 36.112 3.9571 7.2611 7.1266 13.539h-49.283l-7.1266-13.539-22.76-43.383z",
    strokeWidth: 0.96826
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAstrovault);
export default __webpack_public_path__ + "static/media/astrovault.7fbab3e34179cd615fa7b17118c8a9da.svg";
export { ForwardRef as ReactComponent };